import { render, staticRenderFns } from "./tietosuojaseloste.vue?vue&type=template&id=3ecedb0a&scoped=true&"
import script from "./tietosuojaseloste.vue?vue&type=script&lang=ts&"
export * from "./tietosuojaseloste.vue?vue&type=script&lang=ts&"
import style0 from "./tietosuojaseloste.vue?vue&type=style&index=0&id=3ecedb0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecedb0a",
  null
  
)

export default component.exports